module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBoldItalic.ae6d697.eot";